import {
  listFileRequests,
  createProjectFileRequest,
  updateProjectFileRequest,
  deleteProjectFileRequest,
  fileRequestByToken,
  uploadAssetUsingFileRequest
} from '@/api/workflow';

export default {
  namespaced: true,
  state: () => ({
    fileRequests: {
      loading: false,
      error: null,
      items: [],
      projectId: null
    },
    fileRequest: {
      loading: false,
      error: null,
      value: null,
      projectId: null
    }
  }),
  mutations: {
    fetchProjectFileRequestByTokenPending(state) {
      state.fileRequest.loading = true;
      state.fileRequest.error = null;
      state.fileRequest.value = null;
      state.fileRequest.projectId = null;
    },
    fetchProjectFileRequestByTokenSuccess(state, { fileRequest, projectId }) {
      state.fileRequest.loading = false;
      state.fileRequest.error = null;
      state.fileRequest.value = fileRequest;
      state.fileRequest.projectId = projectId;
    },
    fetchProjectFileRequestByTokenError(state, { error }) {
      state.fileRequest.loading = false;
      state.fileRequest.error = true;
      state.fileRequest.value = null;
      state.fileRequest.projectId = null;
    },
    uploadProjectFileRequestByTokenPending(state) {
      state.fileRequest.loading = true;
    },
    uploadProjectFileRequestByTokenSuccess(state) {
      state.fileRequest.loading = false;
      state.fileRequest.error = null;
    },
    uploadProjectFileRequestByTokenError(state, { error }) {
      state.fileRequest.loading = false;
      state.fileRequest.error = true;
    },
    fetchCurrentProjectFileRequestsPending(state) {
      state.fileRequests.loading = true;
      state.fileRequests.error = null;
      state.fileRequests.items = [];
      state.fileRequests.projectId = null;
    },
    fetchCurrentProjectFileRequestsSuccess(state, { fileRequests, projectId }) {
      state.fileRequests.loading = false;
      state.fileRequests.error = null;
      state.fileRequests.items = fileRequests;
      state.fileRequests.projectId = projectId;
    },
    fetchCurrentProjectFileRequestsFailure(state, error) {
      state.fileRequests.loading = false;
      state.fileRequests.error = error;
    },
    setFileRequestsError(state, error) {
      state.fileRequests.error = error;
    },
    addFileRequest(state, fileRequest) {
      state.fileRequests.items = [...state.fileRequests.items, fileRequest];
    },
    setFileRequest(state, fileRequest) {
      state.fileRequests.items = state.fileRequests.items.map(item => {
        if (item.id === fileRequest.id) {
          return fileRequest;
        }
        return item;
      });
    },
    removeFileRequest(state, fileRequest) {
      state.fileRequests.items = state.fileRequests.items.filter(item => item.id !== fileRequest.id);
    }
  },
  actions: {
    async uploadAsset({ commit, state }, { asset, lastUpload, finalAssets, workingFiles }) {
      commit('uploadProjectFileRequestByTokenPending');
      try {
        const payload = {
          projectId: state.fileRequest.projectId,
          ...asset,
          lastUpload,
          finalAssets,
          workingFiles,
          fileId: asset?.resumableFile?.uniqueIdentifier,
          token: state.fileRequest.value.token,
          fileRequestId: state.fileRequest.value.id
        };
        const result = await uploadAssetUsingFileRequest(payload);
        commit('uploadProjectFileRequestByTokenSuccess');
        return result;
      } catch (err) {
        console.error('Server error when creating asset via file requests', err);
        commit('uploadProjectFileRequestByTokenError', 'Error when creating asset via file request with token ');
      }
    },
    async fetchProjectFileRequest({ commit, state }, { projectId, token }) {
      commit('fetchProjectFileRequestByTokenPending');
      try {
        const payload = {
          projectId,
          token
        };
        const fileRequest = await fileRequestByToken(payload);
        commit('fetchProjectFileRequestByTokenSuccess', { fileRequest, projectId });
      } catch (err) {
        console.error('Server error when getting file requests', err);
        commit('fetchProjectFileRequestByTokenError', 'Error when getting file request with token ' + token);
      }
    },
    async fetchCurrentProjectFileRequests({ commit, state, rootState }, group) {
      if (state.fileRequests.projectId === rootState.workflow.currentProjectId) {
        return;
      }
      commit('fetchCurrentProjectFileRequestsPending');
      try {
        const payload = {
          projectIds: rootState.workflow.currentProjectId,
          filters: { group }
        };
        const fileRequests = await listFileRequests(payload);
        if (group != 'delivery') {
          commit('fetchCurrentProjectFileRequestsSuccess', { fileRequests, projectId: payload.projectId });
        }
        return fileRequests;
      } catch (err) {
        console.error('Server error when getting file requests', err);
        commit('fetchCurrentProjectFileRequestsFailure', 'Error when getting file requests');
        throw err
      }
    },
    async addCurrentProjectFileRequest({ commit, rootState }, { fileRequest }) {
      try {
        const payload = {
          projectId: rootState.workflow.currentProjectId,
          ...fileRequest
        };
        const result = await createProjectFileRequest(payload);
        commit('addFileRequest', {
          ...result,
          shouldOpen: true
        });

        return result;
      } catch (err) {
        console.error(`Server error when adding fileRequest`, err);
        throw err;
      }
    },
    async updateCurrentProjectFileRequest({ commit, state, rootState }, { fileRequest }) {
      const previousValue = state.fileRequests.items.find(item => item.id === fileRequest.id);
      commit('setFileRequest', fileRequest);
      try {
        const payload = {
          projectId: rootState.workflow.currentProjectId,
          fileRequestId: fileRequest.id,
          ...fileRequest
        };
        await updateProjectFileRequest(payload);
      } catch (err) {
        console.error(`Server error when updating file request`, err);
        commit('setFileRequest', previousValue);
        commit('setFileRequestsError', 'Error when updating file request');
      }
    },
    async removeCurrentProjectFileRequest({ commit, rootState }, { fileRequest }) {
      commit('removeFileRequest', fileRequest);
      try {
        const payload = {
          projectId: rootState.workflow.currentProjectId,
          fileRequestId: fileRequest.id
        };
        await deleteProjectFileRequest(payload);
      } catch (err) {
        console.error(`Server error when removing file request`, err);
        commit('setFileRequestsError', 'Error when removing file request');
      }
    }
  }
};
